import { useCallback } from 'react'

import { DeleteOptionsMenu } from '../../components/SharedUI/DeleteOptionsMenu'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useUpdateInspectionMutation } from '../../redux/api/inspectionApi'
import { InspectionEntry } from '../../sdk'

interface Props {
  inspection: InspectionEntry
}

const DeleteInspectionMenu: ({ inspection }: Props) => JSX.Element = ({
  inspection
}) => {
  const { accessToken } = useAccessTokenAndShopId()
  const [updateInspection] = useUpdateInspectionMutation()
  const handleDelete = useCallback(
    (isDelete: boolean) => {
      updateInspection({
        authorization: accessToken,
        inspectionEntry: {
          id: inspection.id,
          info: {
            ...inspection.info,
            archived: isDelete ? new Date() : undefined
          }
        }
      })
    },
    [accessToken, inspection.id, inspection.info, updateInspection]
  )

  return (
    <DeleteOptionsMenu
      deleted={!!inspection.info?.archived}
      onDelete={() => handleDelete(true)}
      onUndelete={() => handleDelete(false)}
      entityName="Inspection"
    />
  )
}

export default DeleteInspectionMenu
